<div class="list">
  <div class="actions">
    <a class="button" *ngIf="importedObjectsExists" uiSref="symap.project.constructionObjects.constructionObjectsImported"><i class="fa fa-plus-square"></i>Připravované {{ "CONSTRUCTION_OBJECT_PLURAL_NOMINATIV" | wordtranslate }}</a>
    <a class="button" gmtAuth="admin,manage_input_data" uiSref="symap.project.constructionObjects.newConstructionObject"><i class="fa fa-plus-square"></i>Založit {{ "NEW_CONSTRUCTION_OBJECT_SHORTCUT" | wordtranslate }}</a>
    <a class="button" gmtAuth="admin,manage_input_data" uiSref="symap.project.constructionObjects.newEasement"><i class="fa fa-plus-square"></i>Vložit nové věcné břemeno</a>
  </div>

  <h1>{{ 'CONSTRUCTION_OBJECT_PLURAL_NOMINATIV' | wordtranslate:true }}</h1>

  <filter [list]="list" (onChanged)="pageableList.onFilterChanged($event)">
    <gmt-select
      [multiselect]="true"
      [data]="list.filter.filters.constructionObjectStageId"
      [filter]="{ filters: { validity: 'valid' }, sortOrder: { sortBy: 'name' } }"
      field="values"
      resource="construction-object-stages"
      selectTitle="{{ 'ETAPA_USEK' | wordtranslate }}" logGa
    ></gmt-select>

    <gmt-select *ngIf="!hideColumn('state')"
      [multiselect]="true"
      [data]="list.filter.filters.constructionObjectStatusId"
      field="values"
      resource="construction-object-statuses"
      selectTitle="Stav"
      logGa
    ></gmt-select>

    <gmt-select *ngIf="!hideColumn('mandatary')"
      [multiselect]="true"
      [data]="list.filter.filters.userId"
      [filter]="mandataryFilter"
      field="values"
      resource="users/list"
      selectTitle="Přidělení {{ 'CONSTRUCTION_OBJECT_GENITIV_SHORTCUT' | wordtranslate }}"
      [itemPipe]="userNamePipe"
      logGa
      [restangularService]="restangularSettings"
    ></gmt-select>

    <div
      class="tag"
      [ngClass]="{ active: isGeometricPlansChecked() }"
      title="Zobrazení {{ 'CONSTRUCTION_OBJECT_PLURAL_GENITIV' | wordtranslate }} s GP na věcná břemena"
      (click)="onHideWithoutGP()"
    ><div>Zobrazit pouze věcná břemena</div></div>

    <div
      class="tag"
      [ngClass]="{ active: isAdministratorInvestor() }"
      title="Zobrazení {{ 'CONSTRUCTION_OBJECT_PLURAL_GENITIV' | wordtranslate }} kde je správcem investor"
      (click)="onAdministratorInvestorToggle()"
    ><div>Zobrazit pouze {{ 'CONSTRUCTION_OBJECT_GENITIV_SHORTCUT' | wordtranslate }} - správce investor</div></div>

    <div class="column-100">
      <input class="fulltext" type="text" placeholder="Fultextové hledání..." [(ngModel)]="list.filter.filters.searchText.values[0].id"/>
    </div>
  </filter>

  <div [loading]="list.loading || !settingsLoaded">
    <div class="table-top-container">
      <div class="flex1"><gmt-button [clickAction]="onExport" [gmtDisabled]="!exportEnable"><i class="fa fa-download"></i> Exportovat seznam</gmt-button></div>
      <pagescounter *ngIf="list.itemCount && settingsLoaded && list.list !== null" [list]="list" (callbackRegister)="pageableList.pagescounterCallbackRegister($event)"></pagescounter>
      <div class="page-count-select" *ngIf="list.itemCount && settingsLoaded && list.list !== null">
        <span>Záznamů na stránce</span>
        <gmt-select required="true" [data]="pageableList.dataPaging" field="itemsPerPage" [optionItems]="pageableList.itemsPerPageItems" (changed)="pageableList.changePageItems()" class="min-width-unset"></gmt-select>
      </div>
    </div>

    <table-construction-object [list]="list" (sort)="pageableList.onSort($event.column, $event.ascOrDesc)" *ngIf="settingsLoaded"></table-construction-object>

    <div class="empty-info bordered pb-20 pt-20 centered-text" *ngIf="!list.itemCount && list.list !== null && !list.loading">
      <span>Nebyla nalezena žádná data.</span>
    </div>
  </div>

  <itemscounter
    *ngIf="list.itemCount && list.list !== null" [list]="list"
    (callbackRegister)="pageableList.itemcounterCallbackRegister($event)"
    style="max-width: 100px;"
  ></itemscounter>

  <pagination
    *ngIf="list.itemCount && list.list !== null"
    [list]="list"
    (callbackRegister)="pageableList.paginationCallbackRegister($event)"
  ></pagination>

  <help [helpId]="helpIds.PANEL_CONSTRUCTION_OBJECTS" class="cm-help-page"></help>
</div>
